module.exports = __webpack_public_path__ + "static/media/ic-share-white.ee81f7e1.svg";